import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

// Layout utama untuk halaman yang terproteksi (sudah termasuk Sidebar dan Header)
const ProtectedLayout = ({ isSidebarOpen, setSidebarOpen }) => (
  <div className="app-layout">
    <Sidebar isSidebarOpen={isSidebarOpen} />
    <div className="main-wrapper">
      <Header setSidebarOpen={setSidebarOpen} />
      <main className="content-area">
        <Outlet />
      </main>
    </div>
  </div>
);

const ProtectedRoute = ({ isSidebarOpen, setSidebarOpen }) => {
  const { user } = useContext(AuthContext);
  if (!user) {
    return <Navigate to="/login" />;
  }
  return <ProtectedLayout isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />;
};

export default ProtectedRoute;